import { Injectable } from '@angular/core';
import { MenuItem, MenuData } from '../model/menu.model';
@Injectable({
    providedIn: 'root'
})


export class SingletonService {

    parentMenu: MenuData;

    SetParentMenu(menuData: MenuData) {

        this.parentMenu = menuData;

    }
    GetParentMenu() {
        return this.parentMenu;


    }


}